import { Component, OnInit ,Input} from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { ErrorHandler } from "../utils/error-handler";
import { Chemical } from "../masterdata/models/chemical";
import { LibraryConfiguration } from '../masterdata/models/libraryConfiguration';
import { MdmLibraryConfigurationService } from "./mdm-library-configuration-service";
import { SelectableAssayType } from '../masterdata/models/SelectableAssayType';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';
import { AssayType } from '../masterdata/models/assayType-enum';



@Component({
  selector: 'app-mdm-library-configuration',
  templateUrl: './mdm-library-configuration.component.html',
  styleUrls: ['./mdm-library-configuration.component.css']
})
export class MdmLibraryConfigurationComponent implements OnInit {
 
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() processOptions: any[];
  
  @Input() tableCols:any;
  @Input() masterLists : LibraryConfiguration[];
  @Input() assayTypeOptions:SelectableAssayType[];
  @Input() loading:boolean;

  puid = localStorage.getItem('PUID');
  masterList : LibraryConfiguration;
  isNewMasterList: boolean;
  blocked:boolean=false;
  max_allowed_conc_measurement_diffrence!:number;
  min_number_Of_conc_measurement!:number;
  displayMasterListDialog:boolean=false;
  selectedMasterList:LibraryConfiguration;
  selectedLab:LabMDM;
  selectedAssayType: SelectableAssayType;
  labOption:LabMDM[]=[];
  bufferoptions:Chemical[]=[];
  selectedBuffer:string;
  selectedProcess:any[]=[];
  selctedBufferName:string;
  selectedLabName:string;
  errorHandler: ErrorHandler = new ErrorHandler;
  bufferChemicalOptions:any[];
 
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService,
  private libraryConfigurationService:MdmLibraryConfigurationService) { }

  ngOnInit() {
    this.min_number_Of_conc_measurement=2;
    this.masterList=new LibraryConfiguration();
    this.bufferChemicalOptions = [
      {label:'EB', value:'EB'},
      {label:'Nuclease-free water', value:'Nuclease-free water'},
      {label:'Other', value:'Other'},
      {label:'None', value:'None'},
    ]
  }
  saveProcessOptions()
  {
  this.masterList.process=[]
     this.selectedProcess.forEach(element=>
      {
        this.masterList.process.push(element["name"])
      }
     );
  }

//Add button
  showDialogToAddMasterList()
  {
    this.selectedProcess=[];
    this.isNewMasterList=true;
    this.selectedLab=null;
    this.selectedBuffer=null;
    this.selectedAssayType=null;
    this.masterList=new LibraryConfiguration();
    this.masterList.libQcMminNumberOfConcMeasurements=2;
    this.displayMasterListDialog=true;
  }

  private handleError(error: any) {
  
    let message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
    this.blocked=false;
  }

 checkDefaultLibtypes( )
 {
  let booleanValue= false;
  if(this.masterList.defaultValue)
  {
    booleanValue = this.masterLists.some(libtype=>
     this.masterList.name!=libtype.name &&  libtype.defaultValue 
    );
  }
  
  return booleanValue;
  
 }

//save button
  saveMasterListData()
  {
    if (this.checkDefaultLibtypes())
    {
      this._messageService.addErrorMessage({ severity: 'error',summary: "Default Libtype already exist.",detail:"Please do configure Default value"});
      return
    }
    if(this.masterList.entryQCMaxConc < this.masterList.entryQCMinConc){
      this._messageService.addErrorMessage({ severity: 'error',summary: "Wrong Configuration Made.",detail:"EntryQc Max Conc is Less Than EntryQC Min Conc"});
      return
    }

    if(!this.isDiffrentProcessTypeSelected())
    {
      this._messageService.addErrorMessage({ severity: 'error',summary: "Process with same process Type are selected.",detail:"Please do select diffrent Process"});
      return
    }
    this.masterList.lab=this.selectedLab;
    this.masterList.buffer=this.selectedBuffer;
     this.saveProcessOptions();
    this.masterList.entryQcFAAssayType=this.selectedAssayType.assayType;
    if(this.isNewMasterList)
    {
    this.appendHistory("Library Configuration");  
    this.blocked=true;
    this.libraryConfigurationService.addLibraryConfiguration(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.blocked=false;
        if( ! this.masterLists)
        {
          this.masterLists=[];
          this.masterLists.push(results.data);
        }
        else
        {
          this.masterLists.push(results.data);
        }
        this.displayMasterListDialog = false;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Library Configuration details!', detail: 'Library Configuration details is created.' });
      },
      error => {
        this.handleError(error);
      }
    );
   }

    else
    {  
      this.appendHistory("Library Configuration");  
      this.blocked=true;
      this.libraryConfigurationService.updateLibraryConfiguration(this.masterList).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.masterList = results;
          this.masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results;
          this.masterList = null;
          this.displayMasterListDialog = false;
          this.blocked=false;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Library Configuration details!', detail: 'Library Configuration  details is updated.' });
        },
        error => {
          this.handleError(error);
        }
      );


    }
    
 
  }

  onRowSelect(event:any)
  {
   
    this.masterList=this.cloneMasterList(event.data);
    this.isNewMasterList=false;
    this.selectedAssayType=null;
    this.getAssayType(this.masterList.entryQcFAAssayType)
    this.getActiveOptionsForDropdowns();
    this.displayMasterListDialog=true;
  }
      
  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }
  isDiffrentProcessTypeSelected()
  {
    let booleanVal=true;
    let processType = new Set()
    this.selectedProcess.forEach(process=>{
      if(!process['processType'].includes('Entry_QC')){
        if(processType.has(process['processType'])){
          booleanVal = false;
        }
        processType.add(process['processType'])
      }
    })
    return booleanVal;
  }

  isSaveDisabled(){
      
    return !( this.masterList.name && this.selectedBuffer   && this.masterList.entryQCMaxConc != null   && this.selectedProcess.length >0
       && this.masterList.entryQCMaxVolumeToStartTheLibPrep!= null && this.masterList.entryQCMinConc!= null && this.masterList.defaultAmountToStartTheLibPrep!= null 
       && this.masterList.entryQCMinDNARNAAmount!= null && this.masterList.entryQCMinDQNRQN!= null 
       && this.masterList.entryQCTargetVolume!= null  && this.selectedAssayType
       && this.selectedLab &&  this.masterList.libQCMinMolarity!= null && this.masterList.libQCMinSize!= null 
       && this.masterList.libQCMaxSize!== null && this.masterList.libQCFixedFragmentSize!== null && this.masterList.libQcMmaxAllowedConcMeasurementDiffrence!== null 
       && this.masterList.libQcMminNumberOfConcMeasurements!= null );

  }

  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  } 


  getActiveOptionsForDropdowns(): any {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }  
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }

    );
    this.getSelectedDropDownDetails();
    
  }

  getSelectedDropDownDetails(): any {
    this.selectedBuffer = null;
   
        this.bufferChemicalOptions.forEach(buffer=>{
          if (this.masterList && this.masterList.buffer && buffer.value == this.masterList.buffer )
            this.selectedBuffer=buffer.value;
            this.selctedBufferName=this.masterList.buffer;
        })
        this.selectedProcess = [];
        if(!this.processOptions)
        {
          this.processOptions=[];
        }
        this.processOptions.forEach(process=>{
          if(this.masterList && this.masterList.process && this.masterList.process.includes(process['name']))
          {
            this.selectedProcess.push(process);
          }
        })
      }
  getAssayType(assayType: AssayType) {
        if (assayType != null && assayType != undefined) {
          switch (assayType.toString()) {
            case "HS_LARGE_FRAGMENT": {
              this.selectedAssayType = { label: 'HS Large Fragment', assayType: AssayType.HS_LARGE_FRAGMENT }
              break;
            }
            case "HS_NGS_FRAGMENT": {
              this.selectedAssayType = { label: 'HS NGS Fragment', assayType: AssayType.HS_NGS_FRAGMENT }
              break;
            }
            case "SS_NGS_FRAGMENT": {
              this.selectedAssayType = { label: 'SS NGS Fragment', assayType: AssayType.SS_NGS_FRAGMENT }
              break;
            }
            case  "NO_ASSAY_TYPE":{
              this.selectedAssayType = { label: 'No Assay Type', assayType: AssayType.NO_ASSAY_TYPE }
              break;
            }
            case  "SS_NGS_RNA_Fragment":{
              this.selectedAssayType = { label: 'SS NGS RNA Fragment', assayType: AssayType.SS_NGS_RNA_Fragment }
              break;
            }
            case  "HS_NGS_RNA_Fragment":{
              this.selectedAssayType = { label: 'HS NGS RNA Fragment', assayType: AssayType.HS_NGS_RNA_Fragment }
              break;
            }
    
          }
        }
      }

}

